/** Focus mode — hides the series rail and the on-this-page outline. */
import { getCookie, setCookie } from './cookie'

function applyFocus(on: boolean): void {
  document.body.classList.toggle('focus-mode', on)
  document.querySelectorAll<HTMLElement>('.js-focus').forEach((el) => {
    el.setAttribute('aria-pressed', on ? 'true' : 'false')
    const label = on ? el.dataset.labelOff : el.dataset.labelOn
    if (label) el.setAttribute('aria-label', label)
  })
}

function watchHeroButton(): void {
  const hero = document.getElementById('reading-focus')
  const floating = document.getElementById('focus-toggle')
  if (!hero || !floating || !('IntersectionObserver' in window)) return
  const observer = new IntersectionObserver(([entry]) => {
    floating.classList.toggle('is-stowed', entry.isIntersecting)
  }, { threshold: 0.6 })
  observer.observe(hero)
}

function closeRails(): void {
  document.querySelector('.submenu')?.classList.remove('active')
  document.querySelector('.table-of-contents')?.classList.remove('active')
  document.querySelectorAll('#tools .tool.series, #tools .tool.toc').forEach((el) => {
    el.classList.remove('is-open')
    el.setAttribute('aria-expanded', 'false')
  })
}

export function initFocusMode(): void {
  const buttons = Array.from(document.querySelectorAll<HTMLElement>('.js-focus'))
  if (!buttons.length) return

  const toggle = (): void => {
    const next = !document.body.classList.contains('focus-mode')
    setCookie('focus', next ? 'on' : '', 30)
    applyFocus(next)
    if (next) closeRails()
  }

  applyFocus(getCookie('focus') === 'on')
  watchHeroButton()

  buttons.forEach((btn) => {
    btn.addEventListener('click', toggle)
    btn.addEventListener('keydown', (event) => {
      if (btn instanceof HTMLButtonElement) return
      if (event.key !== 'Enter' && event.key !== ' ') return
      event.preventDefault()
      toggle()
    })
  })
}
